import React from 'react';
import '../Components/ComponentCss/Pyo.css'; // CSS 파일 임포트

const Pyo = ({ theDay, room, rent, surtax, electric, gas ,resRent, resSurtax, resElectric, resGas}) => {
    // "-"인 경우 "납입완료" 처리

    return (
        <div className={"Pyo-info-title"}>
            <div className={'Pyo-years'}>{theDay}</div>
            <div className={'Pyo-rooms'}>{room}</div>
            <div className={'Pyo-pay-info'}>
                <div className={'pay-info-2'}>
                    <div className={'pay-element'}>    {resRent === null ? rent : "납입완료"}
                    </div>
                    <div className={'pay-element'}> {resSurtax === null ? surtax : "납입완료"}</div>
                    <div className={'pay-element'}></div>
                    <div className={'pay-element'}> {resElectric === null ? electric : "납입완료"}</div>
                    <div className={'pay-element-gas'}> {resGas === null ? gas : "납입완료"}</div>
                </div>
            </div>
        </div>
    );
};

export default Pyo;